<script lang="ts">
  import { MARK_GLYPHS, MARK_RADIUS, MARK_SIZE } from "@/lib/toby-mark"

  type Props = {
    size?: number
    class?: string
    inverted?: boolean
    /** Render in the print brand red (#DA291C) instead of the screen red —
        for print collateral. */
    print?: boolean
  }
  const {
    size = 32,
    class: className = "",
    inverted = false,
    print = false,
  }: Props = $props()

  const markClass = $derived(
    inverted ? "text-white" : print ? "text-brand-print" : "text-brand",
  )
  const glyphFill = $derived(
    inverted ? (print ? "var(--brand-print)" : "var(--brand)") : "#fff",
  )
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 {MARK_SIZE} {MARK_SIZE}"
  fill="none"
  role="img"
  aria-label="TOBY icon"
  class="{markClass} {className}"
>
  <rect
    width={MARK_SIZE}
    height={MARK_SIZE}
    rx={MARK_RADIUS}
    fill="currentColor"
  />
  <g
    fill={glyphFill}
    style="font-size:24.7825px;line-height:.9;font-family:Nunito;-inkscape-font-specification:&quot;Nunito, @opsz=32,wght=800&quot;;font-variation-settings:&quot;opsz&quot;32,&quot;wght&quot;800;letter-spacing:.826085;text-anchor:middle;stroke-width:2.06521"
  >
    <path d={MARK_GLYPHS} />
  </g>
</svg>
